import { useQuery } from "react-query";
import * as api from "../api/polling";

export function usePoll(id: number, options = {}) {
  return useQuery(["poll", id], () => api.poll(id), options);
}
